if (!customElements.get('quick-filters')) {
  class QuickFilters extends HTMLElement {
    connectedCallback() {
      this.update = this.update.bind(this);
      this.onClick = this.onClick.bind(this);

      this.update();

      document.addEventListener('on:facet-filters:updated', this.update);
      window.addEventListener('popstate', this.update);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      document.removeEventListener('on:facet-filters:updated', this.update);
      window.removeEventListener('popstate', this.update);
      this.removeEventListener('click', this.onClick);
    }

    hasActiveFacetFilters() {
      const url = new URL(window.location.href);
      for (const key of url.searchParams.keys()) {
        if (key.startsWith('filter.')) return true;
      }
      return false;
    }

    update() {
      this.hidden = this.hasActiveFacetFilters();
    }

    /**
     * Apply filters through the existing facet-filters component (async),
     * falling back to normal navigation if not available.
     */
    onClick(evt) {
      const link = evt.target.closest('a');
      if (!link) return;

      if (!this.contains(link)) return;

      const facetEl = document.querySelector('facet-filters');
      if (!facetEl || typeof facetEl.applyFilters !== 'function') {
        return;
      }

      evt.preventDefault();

      const linkUrl = new URL(link.href, window.location.origin);
      const nextParams = linkUrl.searchParams;

      const currentUrl = new URL(window.location.href);
      const currentSort = currentUrl.searchParams.get('sort_by');
      if (currentSort && !nextParams.get('sort_by')) {
        nextParams.set('sort_by', currentSort);
      }

      nextParams.delete('page');

      facetEl.applyFilters(nextParams.toString(), evt, true);
    }
  }

  customElements.define('quick-filters', QuickFilters);
}
